/*eslint-disable*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Col,
  Row,
  Calendar,
  Badge,
  List,
  Divider,
  Typography,
  Popover,
  Spin,
  Button,
  Input,
  Modal,
  Space,
  notification,
  Popconfirm,
  Select,
  Tabs,
  Tag,
  Tooltip,
  Pagination,
} from "antd";
import "../App.css";
import * as Yup from "yup";
import {
  getAllPreTasks,
  getAllPostTasks,
  getAllTasks,
  getAllTasksDetails,
} from "../Actions/tasksAction";
import { getBirthdate } from "../Actions/birthdateAction";
import { UpdatTask } from "../pages/updateTask";
import {
  createNotification,
  getAllNotification,
  deleteNotification,
} from "../Actions/notificationAction";
import MyTable from "../components/table";
import { SearchOutlined } from "@ant-design/icons";
import { useAuth } from "@clerk/clerk-react";
import useResizeObserver from "../components/useResizeObserver";
import { debounce } from "lodash";
import moment from "moment";
import { useBreakpoints } from "../components/ResponsiveBreakPoints";
import { getAllLeadNotes } from "../Actions/leadNotesAction";
import { getAllLeads, getLeadById, getleadtype } from "../Actions/leadsActions";
import { getUsers, getCurrentUser } from "../Actions/usersAction";
import useColumnSearch from "../Utils/useColumnSearch";
import { setTokenFetcher } from "../Utils/API";

const { TabPane } = Tabs;
const { Title } = Typography;

const Dashboard = ({ currentUser }) => {
  const { getColumnSearchProps } = useColumnSearch();
  const dispatch = useDispatch();

  const hasPermission = useCallback((resource, action) => {
    if (currentUser?.role === "Admin") return true;
    if (resource === "tasks") return true;
    if ((resource === "projects" || resource.startsWith("projects_")) && (action === "index" || action === "show")) return true;
    if (resource === "areas" && action === "index") return true;
    if (!currentUser?.permissions) return false;
    return currentUser.permissions.some(
      (p) => p.resource === resource && p.action === action
    );
  }, [currentUser]);
  const { IsXS, IsSM, IsMD } = useBreakpoints();
  const {
    isGetPreTasksLoading,
    isGetPostTasksLoading,
    preTask,
    allTaskDetails,
    tasksPagination,
    isGetAllTaskDetailsLoading,
  } = useSelector((state) => state.tasks);
  const { users } = useSelector((state) => state.users);
  const { birthdate, isGetBirthdateLoading } = useSelector(
    (state) => state.birthdate,
  );
  const {
    isGetNotificationsLoading,
    isCreateNotificationLoading,
    isDeleteNotificationLoading,
    notifications,
  } = useSelector((state) => state.notifications);
  const { leadNotes } = useSelector((state) => state.leadNotes);
  const { client_birthday, renewal_property, tasks } = birthdate || {};
  const [createDialog, setCreateDialog] = useState(false);
  const { isSignedIn, getToken } = useAuth();
  const [token, setToken] = useState();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        setTokenFetcher(getToken);

        const result = await getToken();

        setToken(result);
      } catch (err) {
        alert(err.message);
      }
    };

    if (isSignedIn) {
      fetchToken();
    }
  }, [isSignedIn, getToken]);

  useEffect(() => {
    if (token) {
      dispatch(getCurrentUser());
      dispatch(getUsers());
      dispatch(getleadtype());
      dispatch(getAllNotification());
    }
  }, [token]);

  const currentUserId = currentUser?.id;

  useEffect(() => {
    if (token && currentUserId) {
      if (hasPermission("leads", "index")) {
        dispatch(getAllLeads(`/leads`));
      }
      dispatch(getBirthdate());
    }
  }, [token, currentUserId]);

  const [showTask, setShowTask] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [CurrentPreTask, setCurrentPreTask] = useState({});
  const [CurrentPostTask, setCurrentPostTask] = useState({});
  const [selectedTab, setSelectedTab] = useState("1");

  const [page, setPage] = useState(1);
  const [tableFilters, setTableFilters] = useState({});
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    if (token && currentUserId) {
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("items", 10);
      params.append("date_filter", selectedTab);

      const searchId = tableFilters.id?.[0] || tableFilters["1"]?.[0];
      const clientName = tableFilters.client_name?.[0] || tableFilters.clientName?.[0];
      const employeeName = tableFilters.user_name?.[0] || tableFilters.employeeName?.[0];
      const leadStatus = tableFilters.lead_status?.[0];

      if (searchId) {
        params.append("search_id", searchId);
      }
      if (clientName) {
        params.append("client_name", clientName);
      }
      if (employeeName) {
        params.append("employee_name", employeeName);
      }
      if (leadStatus) {
        params.append("lead_status", leadStatus);
      }

      if (sortBy && sortOrder) {
        params.append("sort_by", sortBy);
        params.append("sort_order", sortOrder);
      }

      dispatch(getAllTasksDetails(`/tasks?${params.toString()}`));
    }
  }, [token, currentUserId, page, tableFilters, sortBy, sortOrder, selectedTab]);

  const [size, setSize] = useState({ width: 0, height: 0 });

  const onRowSelect = (record) => {
    setCurrentPreTask(record);
    setCurrentPostTask(record);
    setShowSearch(true);
    setShowTask(true);
  };
  const dateFormats = [
    "YYYY-MM-DD",
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    "x",
    "X",
  ];

  const today = moment().startOf("day");
  const yesterday = today.clone().subtract(1, "day");
  const tomorrow = today.clone().add(1, "day");

  // STEP 1: Apply role filter + valid follow_up_date
  const baseTasks = (allTaskDetails || []).filter((task) => {
    if (
      (currentUser?.role === "Employee" || currentUser?.role === "Admin") &&
      task?.user?.id !== currentUser?.id
    ) {
      return false;
    }

    if (!task.follow_up_date) return false;

    const taskDate = moment(task.follow_up_date, dateFormats).startOf("day");
    if (!taskDate.isValid()) return false;

    return true;
  });

  // STEP 2: Split tasks by category
  const todayTasks = baseTasks.filter((task) =>
    moment(task.follow_up_date, dateFormats)
      .startOf("day")
      .isSame(today, "day"),
  );

  const yesterdayTasks = baseTasks.filter((task) =>
    moment(task.follow_up_date, dateFormats)
      .startOf("day")
      .isSame(yesterday, "day"),
  );

  const tomorrowTasks = baseTasks.filter((task) =>
    moment(task.follow_up_date, dateFormats)
      .startOf("day")
      .isSame(tomorrow, "day"),
  );

  const pastTasks = baseTasks.filter((task) => {
    const taskDate = moment(task.follow_up_date, dateFormats).startOf("day");

    const leadStatus = task?.attachable?.lead_status;

    if (leadStatus === "Success" || leadStatus === "Dead") {
      return false;
    }

    return taskDate.isBefore(yesterday, "day");
  });

  const futureTasks = baseTasks.filter((task) =>
    moment(task.follow_up_date, dateFormats)
      .startOf("day")
      .isAfter(tomorrow, "day"),
  );

  // STEP 3: The actual table data based on selected tab
  const serverTabCounts = tasksPagination?.tab_counts;
  const tabCounts = {
    today: serverTabCounts?.today ?? todayTasks.length,
    yesterday: serverTabCounts?.yesterday ?? yesterdayTasks.length,
    tomorrow: serverTabCounts?.tomorrow ?? tomorrowTasks.length,
    past: serverTabCounts?.past ?? pastTasks.length,
    future: serverTabCounts?.future ?? futureTasks.length,
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    if (filters) {
      setTableFilters(filters);
    }
    if (sorter && sorter.field) {
      setSortBy(sorter.field);
      setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
    }
  };

  // const filteredTasks = allTaskDetails.filter((task) => {
  //   if (
  //     (currentUser?.role === "Employee" || currentUser?.role === "Admin") &&
  //     task?.user?.id !== currentUser?.id
  //   ) {
  //     return false;
  //   }

  //   if (!task.follow_up_date) return false;

  //   const taskDate = moment(task.follow_up_date, [
  //     "YYYY-MM-DD",
  //     "DD/MM/YYYY",
  //     "MM/DD/YYYY",
  //     "YYYY-MM-DDTHH:mm:ss.SSSZ",
  //     "x",
  //     "X",
  //   ]).startOf("day");

  //   if (!taskDate.isValid()) return false;

  //   const today = moment().startOf("day");

  //   switch (selectedTab) {
  //     case "1": // Today
  //       return taskDate.isSame(today, "day");
  //     case "2": // Yesterday
  //       return taskDate.isSame(today.clone().subtract(1, "day"), "day");
  //     case "3": // Tomorrow
  //       return taskDate.isSame(today.clone().add(1, "day"), "day");
  //     case "4": // Past
  //       return taskDate.isBefore(today.clone().subtract(1, "day"), "day");
  //     case "5": // Future (after tomorrow)
  //       return taskDate.isAfter(today.clone().add(1, "day"), "day");
  //     default:
  //       return true;
  //   }
  // });

  const dateCellRender = (v) => {
    const date = v.date();
    const month = v.month() + 1;
    const monthStr =
      month.toString().length === 1 ? "0" + month.toString() : month;
    const matchingBirthday =
      client_birthday?.filter(
        (b) => date.toString() === b.date && monthStr === b.month,
      ) || [];

    const renewalProperty =
      renewal_property?.filter((b) => {
        if (!b.renewal_date) return false;
        const renewalMoment = moment(b.renewal_date, "DD/MM/YYYY");
        const renewalDay = renewalMoment.date().toString();
        const renewalMonth = renewalMoment.format("MM");

        return renewalDay === date.toString() && renewalMonth === monthStr;
      }) || [];

    const tasks_data =
      tasks?.filter((b) => {
        if (!b.follow_up_date) return false;
        const followUpDateMoment = moment(b.follow_up_date, "DD/MM/YYYY");
        const followUpDateDay = followUpDateMoment.date().toString();
        const followUpDateMonth = followUpDateMoment.format("MM");

        return (
          followUpDateDay === date.toString() && followUpDateMonth === monthStr
        );
      }) || [];

    const groupedTasks =
      tasks_data.length > 0
        ? tasks_data.reduce((acc, task) => {
            const { user_name, attachment_type, client_name } = task;

            if (!acc[user_name]) {
              acc[user_name] = [];
            }

            acc[user_name].push({ attachment_type, client_name });
            return acc;
          }, {})
        : {};

    let showGreen = false;
    let showRed = false;

    if (tasks_data && tasks_data.length > 0) {
      showGreen = tasks_data.some((task) => task.is_completed === true);
      showRed = tasks_data.some((task) => task.is_completed === false);
    }
    if (
      matchingBirthday?.length > 0 ||
      renewalProperty?.length > 0 ||
      tasks_data?.length > 0
    ) {
      const popoverContent = (
        <div>
          {matchingBirthday.map((mb, i) => (
            <div key={`birthday-${i}`}>
              <strong>{mb.name}'s Birthday</strong>
            </div>
          ))}
          {renewalProperty.map((rp, i) => (
            <div key={`renewal-${i}`}>
              <strong>{rp.client_name}</strong>'s property renewal on{" "}
              {rp.renewal_date}
            </div>
          ))}
          {Object.entries(groupedTasks).map(([userName, taskList], i) => (
            <div key={`user-${i}`}>
              <strong>{userName}'s Tasks:</strong>
              {taskList.map((task, j) => (
                <div key={`task-${i}-${j}`} style={{ marginLeft: "10px" }}>
                  {task.attachment_type} : {task.client_name}
                </div>
              ))}
            </div>
          ))}
        </div>
      );

      return (
        <div
          style={{
            position: "absolute",
            display: "flex",
            gap: "2px",
            top: 27,
            left: "50%",
            transform: "translate(-50%, -50%)",
            justifyContent: "center",
            // alignItems: "center",
          }}
        >
          {matchingBirthday.length > 0 && (
            <Popover content={popoverContent}>
              <Badge
                color="blue"
                style={{ transform: "scale(0.7)", cursor: "pointer" }}
              />
            </Popover>
          )}

          {renewalProperty.length > 0 && (
            <Popover content={popoverContent}>
              <Badge
                color="purple"
                style={{ transform: "scale(0.7)", cursor: "pointer" }}
              />
            </Popover>
          )}

          {showGreen && (
            <Popover content={popoverContent}>
              <Badge
                status="success"
                style={{ transform: "scale(0.7)", cursor: "pointer" }}
              />
            </Popover>
          )}

          {showRed && (
            <Popover content={popoverContent}>
              <Badge
                status="error"
                style={{ transform: "scale(0.7)", cursor: "pointer" }}
              />
            </Popover>
          )}
        </div>
      );
    }
    // birthdate.forEach(element => {
    //   if (element.date_of_birth) {
    //     const b = element.date_of_birth.slice(0, 2)
    //   //  console.log("Birth Val", b, date.toString())
    //     if (b === date.toString()){
    //       console.log("Birth Val", b)

    //       return (
    //         <div style={{width:'100%'}}>
    //         <li key={element.id}>
    //       <Badge  text={element.name} />
    //     </li>
    //     </div>
    //       )
    //     }
    //   }

    // });
  };

  const statusColors = {
    Hot: "#E63946",
    Warm: "#F4A261",
    Cold: "#3396D3",
    Dead: "#6C757D",
    Success: "#5CB338",
  };

  const Taskcolumns = (users, type) => [
    ...(currentUser?.role === "Admin"
      ? [
          {
            title: "Employee Name",
            dataIndex: "user_name",
            key: "user_name",
            width: 140,
            ...getColumnSearchProps("user_name"),
            onFilter: null,
            fixed: "left",
            render: (record, object) => {
              return (
                <Typography style={{ fontSize: "12px" }}>{record}</Typography>
              );
            },
          },
        ]
      : []),
    {
      title: "Client Name",
      dataIndex: "client_name",
      ...getColumnSearchProps("client_name"),
      onFilter: null,
      key: "client_name",
      width: 120,
      render: (_, record) => {
        const latestNote = record?.attachable?.lead_notes?.length
          ? record?.attachable?.lead_notes[
              record?.attachable?.lead_notes.length - 1
            ].text
          : "No notes available";

        if (record.attachment_type === "Lead") {
          return (
            <Tooltip title={latestNote}>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {/* <Badge
                  color={
                    statusColors[record?.attachable?.lead_status] || "gray"
                  }
                  className="badge"
                /> */}
                <Typography.Text style={{ fontSize: "12px" }}>
                  {record.client_name}
                </Typography.Text>
              </span>
            </Tooltip>
          );
        }

        return (
          <Typography.Text style={{ fontSize: "12px" }}>
            {record.client_name}
          </Typography.Text>
        );
      },
    },
    {
      title: "Lead Status",
      key: "lead_status",
      dataIndex: "lead_status",
      width: 120,
      ...getColumnSearchProps("lead_status"),
      onFilter: null,

      render: (_, record) => {
        const status = record?.attachable?.lead_status;
        if (!status) return "-";

        const color = statusColors[status] || "gray";

        return (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <Badge color={color} className="badge" />
            <Typography.Text style={{ fontSize: "12px" }}>
              {status}
            </Typography.Text>
          </span>
        );
      },
    },

    {
      title: "ID",
      width: 50,
      dataIndex: "id",
      // className:"tableText",
      key: "id",
      ...getColumnSearchProps("id"),
      onFilter: null,
      render: (id) => {
        return <Typography style={{ fontSize: "12px" }}>{id}</Typography>;
      },
    },
    {
      title: "Due Date",
      width: 100,
      dataIndex: "due_date",
      key: "due_date",
      sorter: true,
      render: (due_date) => {
        if (!due_date) return "-";
        const formattedDate = moment(due_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div style={{ fontSize: "12px" }}>
            {formattedDate !== "Invalid date" ? formattedDate : "-"}
          </div>
        );
      },
    },
    {
      title: "Communication Date",
      dataIndex: "communication_date",
      key: "communication_date",
      width: 120,
      sorter: true,
      render: (communication_date) => {
        if (!communication_date) return "-";
        const formattedDate = moment(communication_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div style={{ fontSize: "12px" }}>
            {formattedDate !== "Invalid date" ? formattedDate : "-"}
          </div>
        );
      },
    },
    {
      title: "Follow up Date",
      dataIndex: "follow_up_date",
      key: "follow_up_date",
      width: 100,
      sorter: true,
      render: (follow_up_date) => {
        if (!follow_up_date) return "-";
        const formattedDate = moment(follow_up_date, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY");

        return (
          <div style={{ fontSize: "12px" }}>
            {formattedDate !== "Invalid date" ? formattedDate : "-"}
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "attachment_type",
      key: "attachment_type",
      width: 100,
      render: (attachment_type) => {
        return <div style={{ fontSize: "12px" }}>{attachment_type}</div>;
      },
    },
    {
      title: "Task Status",
      dataIndex: "is_completed",
      key: "is_completed",
      width: 100,
      render: (is_completed) => {
        return (
          <div style={{ fontSize: "12px" }}>
            {is_completed ? "Completed" : "Pending"}
          </div>
        );
      },
    },
    // {
    //   title: "Note",
    //   width: 120,
    //   dataIndex: "note",
    //   key: "note",
    //   filters: [
    //     {
    //       text: "note",
    //       value: "note",
    //     },
    //   ],
    //   onFilter: (value, record) => record.note.indexOf(value) === 0,
    // },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: 100,
      render: (id, object) => (
        <TaskActionComponent
          id={id}
          type={type}
          attachment_type={object?.attachment_type}
          leadId={object?.attachable?.id}
          the_lead={object?.attachable}
          selectedTab={selectedTab}
          page={page}
        />
      ),
    },
  ];
  const handlePanelChange = () => {
    dispatch(getBirthdate());
  };
  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== size.width || newHeight !== size.height) {
        setSize({ width: newWidth, height: newHeight });
      }
    }, 200),
    [size],
  );
  useResizeObserver(handleResize);

  // console.log({ allTaskDetails, filteredTasks });

  return (
    <>
      <Row>
        <Col sm={24} md={12} lg={12}>
          <Tabs
            activeKey={selectedTab}
            onChange={(key) => {
              setPage(1);
              setSelectedTab(key);
            }}
          >
            <TabPane tab={`Today (${tabCounts.today})`} key="1" />
            <TabPane tab={`Yesterday (${tabCounts.yesterday})`} key="2" />
            <TabPane tab={`Tomorrow (${tabCounts.tomorrow})`} key="3" />
            <TabPane tab={`Past (${tabCounts.past})`} key="4" />
            <TabPane tab={`Future (${tabCounts.future})`} key="5" />
          </Tabs>
        </Col>
        <Col
          sm={24}
          md={12}
          lg={12}
          className="badgeCol"
          style={{
            display: "flex",
            gap: "12px",
            marginBottom: IsXS || IsSM ? "20px" : "",
          }}
        >
          <Badge color="orange" text="Warm" className="badge" />
          <Badge color="red" text="Hot" className="badge" />
          <Badge color="blue" text="Cold" className="badge" />
          <Badge color="gray" text="Dead" className="badge" />
          <Badge color="green" text="Success" className="badge" />
        </Col>
      </Row>
      <Row gutter={[20, 20]}>
        <Col span={24} style={{ paddingBottom: "30px" }}>
          {/* <Row justify="space-between">
            <Col>
              <Title level={4}>
                Open Tasks({postTask.length})
              </Title>
            </Col>
          </Row> */}
          <Spin spinning={isGetPostTasksLoading || isGetAllTaskDetailsLoading}>
            <MyTable
              columns={Taskcolumns(users, "all")}
              data={allTaskDetails}
              onChange={handleTableChange}
              onRowSelect={(filteredTasks) => onRowSelect(filteredTasks)}
            />
            {(tasksPagination?.total_length || (allTaskDetails && allTaskDetails.length) || 0) > 0 && (
              <Row
                justify="end"
                style={{ marginTop: "16px", marginBottom: "16px" }}
              >
                <Col>
                  <Pagination
                    responsive={true}
                    size="small"
                    current={page}
                    pageSize={10}
                    onChange={(p) => setPage(p)}
                    total={tasksPagination?.total_length || (allTaskDetails && allTaskDetails.length) || 0}
                    showSizeChanger={false}
                  />
                </Col>
              </Row>
            )}
          </Spin>
        </Col>
        {/* <Col span={24} style={{ paddingBottom: "30px" }}>
          <Row justify="space-between">
            <Col>
              <Title level={4}>
                Completed Tasks({preTask.length})
              </Title>
            </Col>
          </Row>
          <Spin spinning={isGetPreTasksLoading}>
            <MyTable
              columns={Taskcolumns(users, "pre")}
              data={preTask}
              onRowSelect={(record) => onRowSelect(record)}
            />
          </Spin>
        </Col> */}
      </Row>

      <Row gutter={[20, 20]}>
        <Col xl={12} lg={12} md={12} sm={24} xs={24}>
          <Row justify="space-between">
            <Col>
              <Typography style={{ fontSize: "20px", fontWeight: 600 }}>
                Notifications({notifications?.length})
              </Typography>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={() => setCreateDialog(true)}
                style={{ marginLeft: 20, fontWeight: 500, color: "#FFFFF" }}
              >
                Create
              </Button>
            </Col>
          </Row>
          <Divider style={{ marginTop: "16px" }} />
          <Row>
            <Col span={24}>
              <Spin
                spinning={
                  isGetNotificationsLoading ||
                  isCreateNotificationLoading ||
                  isDeleteNotificationLoading
                }
              >
                <List
                  bordered
                  dataSource={notifications}
                  renderItem={(item) => (
                    <List.Item id={item.id}>
                      <Typography.Text>{item.text}</Typography.Text>
                      <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => dispatch(deleteNotification(item.id))}
                      >
                        <Button type="link">Delete</Button>
                      </Popconfirm>
                    </List.Item>
                  )}
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                />
              </Spin>
            </Col>
          </Row>
        </Col>
        <Col xl={12} lg={12} md={12} sm={24} xs={24}>
          <Spin spinning={isGetBirthdateLoading}>
            <Calendar
              fullscreen={false}
              dateCellRender={dateCellRender}
              onPanelChange={() => handlePanelChange()}
              headerRender={({ value, onChange }) => {
                const month = value.month();

                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      paddingBottom: "15px",
                      width: "100%",
                    }}
                  >
                    <div>
                      <Select
                        value={month}
                        onChange={(newMonth) => {
                          const newValue = value.clone().month(newMonth);
                          onChange(newValue);
                        }}
                        style={{ width: 120 }}
                      >
                        {moment.months().map((month, index) => (
                          <Select.Option key={index} value={index}>
                            {month}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                );
              }}
              style={{ position: "relative" }}
              className="calenderClass"
            />
          </Spin>
        </Col>
      </Row>
      {createDialog && (
        <CreateNotification
          createDialog={createDialog}
          setCreateDialog={setCreateDialog}

          // handleDialog={() => setCreateDialog(true)}
        />
      )}
    </>
  );
};

const TaskActionComponent = ({ id, type, attachment_type, leadId, selectedTab, page }) => {
  const [taskOpen, setTaskOpen] = useState(false);

  return (
    <>
      <UpdatTask
        id={id}
        type={type}
        taskOpen={taskOpen}
        setTaskOpen={setTaskOpen}
        attachment_type={attachment_type}
        leadId={leadId}
        selectedTab={selectedTab}
        page={page}
      />
    </>
  );
};

export default Dashboard;

const schema = Yup.object().shape({
  text: Yup.string().required("Required"),
});
const { TextArea } = Input;
const { Text } = Typography;

const CreateNotification = (props) => {
  const dispatch = useDispatch();
  const { createDialog, setCreateDialog } = props;
  const { handleSubmit, errors, control, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const handleCreateNotification = (data, event) => {
    event.preventDefault();
    data.published = true;
    dispatch(createNotification(data));
    setCreateDialog(false);
    reset();
  };
  const handleCancel = () => {
    setCreateDialog(false);
    reset();
  };
  return (
    <>
      {/* <Spin
      spinning={
        isCreateNotificationLoading
      }
    ></Spin> */}

      <Modal
        title="Create Notification"
        visible={createDialog}
        onCancel={() => handleCancel()}
        footer={null}
        maskClosable={false}
        centered
      >
        {/* <Row>
          <Col xl={12} lg={12} md={12} sm={24} xs={24}> */}
        <form onSubmit={handleSubmit(handleCreateNotification)}>
          <Col>
            <Col>
              <Text>Note</Text>
              <Controller
                as={TextArea}
                name="text"
                control={control}
                rows={4}
                showCount
                maxLength={100}
              />
              {errors.text && (
                <span className="error_style">Note is required</span>
              )}
              <Button
                type="primary"
                htmlType="submit"
                block
                style={{ top: 10 }}
              >
                Create Notification
              </Button>
            </Col>
          </Col>
        </form>
        {/* </Col>
        </Row> */}
      </Modal>
    </>
  );
};
